import React, { useEffect, useState } from "react";
import DesktopMenu from "../../../../common/DesktopMenu/index";
import MobileMenu from "../../../../common/MobileMenu/index";
import useWindowSize from "../../../../common/windowSize";
import NewFooter from "../../../../common/NewFooter";
import BackButton from "../../../Products/BackButton";
import { useTranslation } from "react-i18next";
import BDLogo from '../../../../assets/home/bacchus-drinks-logo.svg';
import { 
  Background, 
} from "../../../../common/Faq/styles";
import {
  SettingsHeader,
  Title
} from '../../styles';
import { 
  QuestionWrapper,
  QuestionP,
  AnswerP
} from "../../../../common/Faq/styles";
import { PrivacyPolicyLogo } from './styles';

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  const size = useWindowSize();
  const [mobileMenu, setMobileMenu] = useState(false);

  useEffect(() => {
    if (size.width < 1200) {
      setMobileMenu(true);
    } else {
      setMobileMenu(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <React.Fragment>
      {mobileMenu ? <MobileMenu single={true}/> : <DesktopMenu single={true}/> }
      <Background marginTop adminPanel>
        <SettingsHeader style={{ marginBottom: '50px' }}>
          <BackButton userPanel/>
          <Title>
            {t("privacyPolicy")}
          </Title>
        </SettingsHeader>
        <PrivacyPolicyLogo src={BDLogo} />
        <QuestionWrapper>
           <AnswerP>{t("privacyPolicyHas")}</AnswerP>
           <QuestionP>{t("whatPersonalInformation")}</QuestionP>
           <AnswerP>{t("whenOrdering")}</AnswerP>
           <QuestionP>{t("whenCollect")}</QuestionP>
           <AnswerP>{t("collectInformation")}</AnswerP>
           <QuestionP>{t("howDoWeUse")}</QuestionP>
           <AnswerP>{t("weMayUse")}</AnswerP>
           <AnswerP>{t("toFollowUp")}</AnswerP>
           <AnswerP>{t("howDoWeProtectSt")}<br />{t("howDoWeProtectNd")}</AnswerP>
           <AnswerP>{t("weUseRegular")}</AnswerP>
           <AnswerP>{t("yourPersonalInformation")}</AnswerP>
           <AnswerP>{t("weImplement")}</AnswerP>
           <AnswerP>{t("allTransactions")}</AnswerP>
           <QuestionP>{t("doWeUseCookies")}</QuestionP>
           <AnswerP>{t("cookiesAreSmall")}</AnswerP>
           <QuestionP>{t("useCookies")}</QuestionP>
           <AnswerP>{t("compileAggregateSt")}<br />{t("compileAggregateNd")}<br />{t("compileAggregateRd")}</AnswerP>
           <QuestionP>{t("thirdParty")}</QuestionP>
           <AnswerP>{t("weDoNotSell")}</AnswerP>
           <QuestionP>{t("thirdPartyLinks")}</QuestionP>
           <AnswerP>{t("notInclude")}</AnswerP>
           <QuestionP>{t("google")}</QuestionP>
           <AnswerP>{t("googleAdvertising")}<a href="https://support.google.com/adwordspolicy/answer/1316548?hl=en">link</a>. {t("notEnabledGoogle")}</AnswerP>
           <QuestionP>{t("coppa")}</QuestionP>
           <AnswerP>{t("whenItComes")}<br />{t("weDoNotSpecifically")}</AnswerP>
           <AnswerP>{t("doWeLetThird")}</AnswerP>
       </QuestionWrapper>
      </Background>
      <NewFooter />
    </React.Fragment>
  );
};

export default PrivacyPolicy;
